<template>
  <BaseLayout>
    <template v-slot:top_buttons>
      <DocLink docKey="strategies" text="Помощь по разделу" />
    </template>
    <LoadingBlock :loading="strategyLoading">
      <div id="wizard-create-deal" class="bs-stepper vertical mt-2">
        <div class="bs-stepper-header border-end">
          <div class="step" :class="active_step === 'strategy-settings' ? 'active' : ''"
            data-target="#strategy-settings">
            <button type="button" class="step-trigger" @click="changeTab('strategy-settings')">
              <span class="bs-stepper-circle"><i class="ti ti-settings ti-sm"></i></span>
              <span class="bs-stepper-label">
                <span class="bs-stepper-title">Настройки</span>
                <span class="bs-stepper-subtitle"></span>
              </span>
            </button>
          </div>
          <div class="line"></div>
          <div class="step" :class="getStepClass('strategy-products')"
            data-target="#strategy-products">
            <div v-tooltip.right="productsDisabledReason" class="d-inline-block">
              <button type="button" class="step-trigger" @click="changeTab('strategy-products')"
                :disabled="productsDisabled">
                <span class="bs-stepper-circle"><i class="ti ti-id ti-sm"></i></span>
                <span class="bs-stepper-label">
                  <span class="bs-stepper-title">Товары</span>
                  <span class="bs-stepper-subtitle"></span>
                </span>
              </button>
            </div>
          </div>
          <div class="line"></div>

          <div class="step" :class="active_step === 'strategy-additional' ? 'active' : ''"
            data-target="#strategy-additional">
            <div v-tooltip.right="saveDisabledReason" class="d-inline-block">
              <button type="button" class="step-trigger" @click="changeTab('strategy-additional')"
                :disabled="isSaveDisabled">
                <span class="bs-stepper-circle"><i class="ti ti-settings-2 ti-sm"></i></span>
                <span class="bs-stepper-label">
                  <span class="bs-stepper-title">Дополнительно</span>
                  <span class="bs-stepper-subtitle"></span>
                </span>
              </button>
            </div>
          </div>
          <div class="line"></div>

          <hr class="mt-2 mb-2">
          <div class="step" :class="active_step === 'strategy-run' ? 'active' : ''" data-target="#strategy-run">
            <div v-tooltip.right="runDisabledReason" class="d-inline-block">
              <button type="button" class="step-trigger" @click="changeTab('strategy-run')" :disabled="runDisabled">
                <span class="bs-stepper-circle"><i class="ti ti-credit-card ti-sm"></i></span>
                <span class="bs-stepper-label">
                  <span class="bs-stepper-title">Запуск стратегии</span>
                  <span class="bs-stepper-subtitle"></span>
                </span>
              </button>
            </div>
          </div>
          <div class="line"></div>
        </div>
        <div class="bs-stepper-content">
          <!-- Strategy settings -->
          <div id="strategy-settings" class="content" :class="active_step === 'strategy-settings' ? 'active' : ''">
            <div class="row g-6">
              <StrategySettings :isNew="isNew" v-model:strategy="strategy" />
              <input type="hidden" v-model="strategy.name" />

              <div class="col-12 d-flex justify-content-between">
                <button class="btn btn-label-secondary btn-prev" disabled>
                  <i class="ti ti-arrow-left ti-xs me-sm-2 me-0"></i>
                  <span class="align-middle d-sm-inline-block d-none">Предыдущий шаг</span>
                </button>
                <div v-tooltip.bottom="productsDisabledReason || ''" class="d-inline-block">
                  <button class="btn btn-primary btn-next" @click="changeTab('strategy-products')"
                    :disabled="productsDisabled">
                    <span class="align-middle d-sm-inline-block d-none me-sm-2">Следующий шаг</span>
                    <i class="ti ti-arrow-right ti-xs"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Strategy products -->
          <div id="strategy-products" class="content" :class="active_step === 'strategy-products' ? 'active' : ''">
            <ValueForAllProducts v-if="isValueForAllProducts" :value_type="strategy.pricing_parameters.type"
              v-model:value="strategy.pricing_parameters.value_for_all" />
            <ProductsByFilters v-show="isProductsByFilters" :filters="strategy.filters" @update:filters="updateFilters"
              ref="ProductsByFilters" />
            <ProductsById v-show="isProductsById" v-model:product_ids="strategy.product_ids"
              v-model:value_individual="strategy.pricing_parameters.value_individual"
              :value_set_type="strategy.pricing_parameters.value_set_type"
              :value_type="strategy.pricing_parameters.type" />

            <div class="row g-6 mt-2">
              <div class="col-12 d-flex justify-content-between">
                <button class="btn btn-label-secondary btn-prev" @click="changeTab('strategy-settings')">
                  <i class="ti ti-arrow-left ti-xs me-sm-2 me-0"></i>
                  <span class="align-middle d-sm-inline-block d-none">Предыдущий шаг</span>
                </button>
                <div v-tooltip.bottom="saveDisabledReason || ''" class="d-inline-block">
                  <button :disabled="isSaveDisabled" class="btn btn-primary btn-next"
                    @click="changeTab('strategy-additional')">
                    <span class="align-middle d-sm-inline-block d-none me-sm-2">Следующий шаг</span>
                    <i class="ti ti-arrow-right ti-xs"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Strategy additional -->
          <div id="strategy-additional" class="content" :class="active_step === 'strategy-additional' ? 'active' : ''">
            <StrategyAdditionalSettings :strategy="strategy" @update:strategy="strategy = $event" :stores="stores" />
            <div class="row g-6 mt-2">
              <div class="col-12 d-flex justify-content-between">
                <button class="btn btn-label-secondary btn-prev" @click="changeTab('strategy-products')">
                  <i class="ti ti-arrow-left ti-xs me-sm-2 me-0"></i>
                  <span class="align-middle d-sm-inline-block d-none">Предыдущий шаг</span>
                </button>
                <div v-tooltip.bottom="saveDisabledReason || ''" class="d-inline-block">
                  <button class="btn btn-primary btn-next" @click="saveStrategy" :disabled="isSaveDisabled">
                    <span class="align-middle d-sm-inline-block d-none me-sm-2">Сохранить настройки</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Strategy-run -->
          <div id="strategy-run" class="content" :class="active_step === 'strategy-run' ? 'active' : ''">
            <StrategyRun v-if="!isNew" :strategy-id="localId" />
          </div>
        </div>
      </div>
      <!-- /Create Strategy Wizard -->
    </LoadingBlock>
  </BaseLayout>
</template>

<script>
import BaseLayout from '@/layouts/Base.vue'
import { PageInfo } from "@/data/page";
import { user } from "@/data/user";
import Strategy from "@/models/strategy";
import { stores } from "@/data/store";
import ProductsByFilters from "@/components/strategy/ProductsByFilters.vue";
import ValueForAllProducts from "@/components/strategy/ValueForAllProducts.vue";
import ProductsById from "@/components/strategy/ProductsById.vue";
import StrategyRun from "@/components/strategy/StrategyRun.vue";
import { newStrategy, updateStrategy, getStrategy } from "@/api/strategies";
import LoadingBlock from "@/components/page/LoadingBlock.vue";
import { Message, Messages } from "@/data/messages";
import StrategySettings from "@/components/strategy/StrategySettings"
import StrategyAdditionalSettings from "@/components/strategy/StrategyAdditionalSettings"
import Tooltip from 'primevue/tooltip';
import DocLink from "@/components/tools/DocLink.vue";

export default {
  name: 'StrategyView',
  components: {
    StrategySettings,
    StrategyAdditionalSettings,
    ProductsById,
    ValueForAllProducts,
    ProductsByFilters,
    BaseLayout,
    LoadingBlock,
    StrategyRun,
    DocLink
  },
  directives: {
    tooltip: Tooltip
  },
  props: {
    isNew: {
      type: Boolean,
      required: true
    },
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      stores: [],
      active_step: 'strategy-settings',
      strategy: Strategy.createNew(),
      strategyLoading: false,
      strategyChanged: true,
      localId: this.id,
      ignoreNextStrategyWatch: false
    }
  },
  computed: {
    productsDisabled() {
      return !(this.strategy.store_id && this.strategy.name);
    },
    productsDisabledReason() {
      if (!this.strategy.store_id) {
        return 'Выберите магазин'
      }
      if (!this.strategy.name) {
        return 'Введите название стратегии'
      }
      return ''
    },
    runDisabled() {
      if (this.strategyChanged) {
        return true
      }
      if (!this.strategy.is_active) {
        return true
      }
      if (this.isNew) {
        return true
      }
      return false
    },
    runDisabledReason() {
      if (this.strategyChanged || this.isNew) {
        return 'Сохраните изменения перед запуском.'
      }
      if (!this.strategy.is_active) {
        return 'Стратегия неактивна. Активируйте стратегию для запуска.'
      }
      return ''
    },
    isSaveDisabled() {
      return !this.strategy.verify()
    },
    saveDisabledReason() {
      const errors = this.strategy.getErrors()
      if (errors && errors.length > 0) {
        return errors.join(', ')
      }
      return null
    },
    isProductsByFilters() {
      return this.strategy.product_selection_type === 'by_filter'
    },
    isProductsById() {
      return this.strategy.product_selection_type === 'by_id'
    },
    isValueForAllProducts() {
      return this.strategy.pricing_parameters.value_set_type === 'for_all'
    },
    isActiveValueSetTypeIndividual() {
      return this.strategy.product_selection_type !== 'by_filter'
    }
  },
  methods: {
    changeTab(tabName) {
      this.active_step = tabName;
    },
    getStepClass(stepName) {
      return {
        'step': true,
        'active': this.active_step === stepName
      }
    },
    async loadStrategy() {
      if (!this.localId) return
      this.strategyLoading = true
      const res = await getStrategy(this.localId)
      this.ignoreNextStrategyWatch = true
      this.strategy = new Strategy(res.data)
      this.strategy.resetChangeTracking()
      this.strategyChanged = false
      this.strategyLoading = false
    },
    updateFilters(filters) {
      this.strategy.filters = filters
    },
    async saveStrategy() {
      this.strategyLoading = true
      let result
      try {
        if (this.isNew) {
          this.strategy.company = user.active_company
          result = await newStrategy(this.strategy)
        } else {
          const strategyId = this.strategy.id || this.localId
          result = await updateStrategy(strategyId, this.strategy)
        }

        const message = new Message()
        if (result.status === 200 || result.status === 201) {
          if (this.isNew) {
            message.text = 'Стратегия успешно создана'
            const created = result.data || {}
            const strategy_id = created.id
            this.localId = strategy_id
            this.ignoreNextStrategyWatch = true
            this.strategy = new Strategy(created)
            this.strategy.resetChangeTracking()
            this.strategyChanged = false
            await this.$router.push(`/strategies/${strategy_id}`)
            this.setPageInfo()
          } else {
            message.text = 'Стратегия успешно обновлена'
            await this.loadStrategy()
          }
          message.type = 'success'
          message.autoremove = 10
        } else if (result.status === 422) {
          message.type = 'failure'
          message.text = 'Ошибка валидации: ' + (result.data.message || 'Проверьте введенные данные')
        } else {
          message.type = 'failure'
          message.text = 'При создании/обновлении стратегии произошла ошибка. Проверьте данные, попробуйте снова или обратитесь в поддержку.'
        }
        Messages.list.push(message)
      } catch (error) {
        const message = new Message()
        message.type = 'failure'
        if (error.response?.status === 422) {
          message.text = 'Ошибка валидации: ' + (error.response.data.message || 'Проверьте введенные данные')
        } else {
          message.text = 'При создании/обновлении стратегии произошла ошибка. Проверьте данные, попробуйте снова или обратитесь в поддержку.'
        }
        Messages.list.push(message)
      } finally {
        this.strategyLoading = false
      }
    },
    setPageInfo() {
      if (this.isNew) {
        PageInfo.title = 'Новая стратегия'
      } else {
        PageInfo.title = 'Редактировать стратегию'
      }
      PageInfo.breadcrumbs = [
        {
          title: 'Главная',
          link: '/'
        },
        {
          title: 'Стратегии',
          link: '/strategies'
        },
        {
          title: PageInfo.title
        }
      ]
    }
  },
  watch: {
    'strategy.pricing_parameters.value_individual': {
      handler() {
        this.isSaveDisabled
      },
      deep: true
    },
    strategy: {
      handler(newVal) {
        if (this.ignoreNextStrategyWatch) {
          this.ignoreNextStrategyWatch = false
          return
        }
        this.strategyChanged = newVal.isChanged();
        if (typeof this.strategy.settings.skip_price_decrease === 'undefined') {
          this.strategy.settings.skip_price_decrease = false;
        }
        if (!this.strategy.settings.rrp_price_type) {
          this.strategy.settings.rrp_price_type = 'standard';
        }
        if (!newVal.settings.additional_params) {
          this.strategy.settings.additional_params = {};
        }
        if (typeof this.strategy.settings.additional_params.ozon_remove_from_actions === 'undefined') {
          this.strategy.settings.additional_params.ozon_remove_from_actions = false;
        }
      },
      deep: true,
      immediate: true
    },
    '$route': {
      handler(to) {
        if (this.isNew || !to.params?.id) return
        if (to.params.id === this.strategy?.id) {
          this.localId = to.params.id
          return
        }
        this.localId = to.params.id
        this.loadStrategy()
        this.setPageInfo()
      },
      immediate: true
    },
    id: {
      handler(newId) {
        this.localId = newId
      },
      immediate: true
    }
  },
  async mounted() {
    this.setPageInfo()
    await user.getUserBase()
    this.stores = await stores.getStores()
  },
}
</script>

<style src="../assets/vuexy/vendor/libs/bs-stepper/bs-stepper.css"></style>